import React from "react";

import "./SpecialEvent.css";
import menuAdulto from "../assets/menu-newyear.jpg"
import menuNiños from "../assets/menu-ninos.jpg"

import { Nav } from "../Nav/Nav.jsx";

export const SpecialEvent = (id) => {
  const mesa = id.match.url.slice(1, 3);

  return (
    <div className="containerL">
      <Nav id={mesa} />

      <div className="conteinerLC">
        <div className="conteinerLB3 animate__animated  animate__zoomIn animate__faster">
          <div>
            <div className="events">
             <img className="eventImg" src={menuAdulto} alt="" />
             <img className="eventImg" src={menuNiños} alt="" />
            </div>
            <div className="linkWpSpecial">
              <svg
                height="30"
                viewBox="0 0 549 478"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M50.7667 289.705L376.313 289.705L274.767 391.252C255.355 410.664 255.355 442.773 274.767 462.935C294.179 482.347 326.288 482.347 346.449 462.935L533.863 274.775C553.275 255.363 553.275 223.253 533.863 203.092L345.703 14.932C335.994 5.22373 322.557 -1.42304e-05 309.864 -1.42304e-05C297.171 -1.42304e-05 283.728 5.22919 274.025 14.932C254.613 34.344 254.613 66.4533 274.025 86.6147L376.317 188.167L50.7707 188.167C23.1453 188.167 -1.63442e-05 210.568 -1.63442e-05 238.937C-1.63442e-05 267.312 22.4013 289.708 50.7707 289.708L50.7667 289.705Z"
                  fill="black"
                />
              </svg>
              <a

                className="links"
                href="http://wa.me/542921422999?text=Hola Quisiera Hacer una reserva para la cena de Naviidad "
                Target="_blank"
              >
                <svg
                  className="linkC wp"
                  width="50"
                  height="50"
                  viewBox="0 0 550 550"

                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    className="redes wap"
                    d="M277.714 0C134.287 0 17.5939 116.693 17.5939 260.12C17.5939 304.005 28.7398 347.26 49.8753 385.584L0.885937 504.105C-0.817129 508.225 -0.0255187 512.944 2.92233 516.277C5.16713 518.824 8.3702 520.225 11.6723 520.225C12.6984 520.225 13.7349 520.09 14.7505 519.808L145.376 484.038C185.376 507.726 231.016 520.22 277.709 520.22C421.136 520.22 537.829 403.538 537.829 260.1C537.834 116.674 421.136 0.00705973 277.709 0.00705973L277.714 0ZM393.115 331.147L366.173 383.349C364.126 387.308 360.079 389.667 355.808 389.667C354.678 389.667 353.532 389.506 352.402 389.162C273.199 364.985 218.015 306.167 212.015 299.578C206.437 294.619 159.922 251.547 135.822 172.589C134.176 167.198 136.619 161.401 141.634 158.818L193.842 131.881C199.54 128.933 206.561 131.151 209.53 136.844L239 193.251C241.052 197.173 240.703 201.912 238.114 205.496L202.874 254.157C216.713 272.616 227.65 282.261 227.869 282.46C228.056 282.616 228.192 282.814 228.359 282.98C228.546 283.163 228.76 283.309 228.937 283.507C229.228 283.835 245.239 301.523 271.921 321.324L319.483 286.876C323.067 284.282 327.806 283.944 331.728 285.985L388.144 315.459C393.832 318.427 396.045 325.443 393.108 331.147L393.115 331.147Z"
                    fill="#03C100"
                  />
                </svg>
              </a>
              <svg
                height="30"
                viewBox="0 0 550 500"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M498.56 188.56H173.013L274.56 87.0134C293.972 67.6014 293.972 35.4921 274.56 15.3307C255.148 -4.08127 223.039 -4.08127 202.877 15.3307L15.464 203.491C-3.94797 222.903 -3.94797 255.012 15.464 275.173L203.624 463.333C213.332 473.042 226.769 478.265 239.463 478.265C252.155 478.265 265.599 473.036 275.301 463.333C294.713 443.921 294.713 411.812 275.301 391.651L173.009 290.099H498.556C526.181 290.099 549.327 267.697 549.327 239.328C549.327 210.953 526.925 188.557 498.556 188.557L498.56 188.56Z"
                  fill="black"
                />
              </svg>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
